import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import MakeAPICall from "../../apiCalls/common";
import {
    addInternalNotesToAssessmentFromInstantSwitch,
    changeOnlineAssessmentStatusAPI,
    deleteOnlineAssessmentAPI,
    exportOnlineAssessmentCSVAPI,
    getOrderHistoryAPI,
    getOrderHistoryWithFilterAPI,
    sendNotificationToPatientFromInstantSwitch,
    updateDoctorContactByTimeAPI
} from "../../apiRoutes";
import {
    converToUtc,
    convertToBrisbaneTimeWithEndDay,
    convertToBrisbaneTimeWithStartDay,
    getFormattedDate
} from "../../utils/dateTimeHelper";
import { sortData } from "../../utils/commonMethods";
import appRoutes from "../../routes/appRoutes";
import Loader from "../../components/loader";
import Button from "../../components/button";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTableSearchByFilter from "../../components/datatable/customDataTableSearchByFilter";
import CustomModal from "../../components/modal";
import Logo from "../../assets/images/instant_switch_logo.png";
import searchFilterList from "../../constants/searchFilterList";
import { IS_ASSESSMENT_TYPES, ORDER_HISTORY_FILTERS, ORDER_HISTORY_STATUS } from "../../constants/helperConstants";
import InstantSwitchPatientContactForm from "../../containers/InstantSwitchPatientContactForm";
import SendInstantSwitchNotificationForm from "../../containers/PatientsForms/sendInstantSwitchNotification";
import InternalNotesForPatientInstantSwitchForm
    from "../../containers/PatientsForms/internalNotesForPatientInstantSwitch";
import momentTz from "moment-timezone";
import { UncontrolledTooltip } from "reactstrap";
import moment from "moment";

const OnlineAssessmentListPage = props => {
    let history = useHistory();
    const [startDate, setStartDate] = useState(moment(convertToBrisbaneTimeWithStartDay(moment().subtract(7, 'days'))));
    const [endDate, setEndDate] = useState(moment(convertToBrisbaneTimeWithEndDay(moment())));
    const [filter, setFilter] = useState("1");
    const [consultNatureFilter, setConsultNatureFilter] = useState(null);
    const [consultDurationFilter, setConsultDurationFilter] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [apiCallParams, setApiCallParams] = useState(null);
    const [apiCallParams1, setApiCallParams1] = useState(null);
    const [apiCallParams2, setApiCallParams2] = useState(null);
    const [currFilters, setCurrFilters] = useState(
        props.location && props.location.state && props.location.state.currPageNo
            ? {
                skip: props.location.state.currPageNo.skip,
                limit: props.location.state.currPageNo.limit
            }
            : {
                skip: 0,
                limit: 10
            }
    );
    const [onlineAssessment, setOnlineAssessment] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [showErrModal, setShowErrModal] = useState(false);
    const [errModalText, setErrModalText] = useState("");

    const [selectedAssessment, setSelectedAssessment] = useState(''); // this will store only id
    const [selectedAssessmentData, setSelectedAssessmentData] = useState({}); // this will be useful for notification and logs

    const [showDeleteAssessmentModel, setShowDeleteAssessmentModel] = useState(false);

    const [showCrossIcon, setShowCrossIcon] = useState(false);

    const [statusBlock, setStatusBlock] = useState('');

    // change patient preferred time
    const [openChangePreferredTimeModel, setOpenChangePreferredTimeModel] = useState(false);
    // const [selectedDoctorContactByTime, setSelectedDoctorContactByTime] = useState('');
    // const doctorContactByTimeOptions = ["Anytime", "During normal business hours", "After hours", "Specific time period"];

    // change draft to to be assessed status
    const [openDraftStatusChangeModel, setOpenDraftStatusChangeModel] = useState(false);

    const [showSendNotificationModal, setShowSendNotificationModal] = useState(false);
    const [showLogsModel, setShowLogsModel] = useState(false);

    const tableHeaders = [
        {
            key: "appointmentId",
            value: "Assessment ID"
        },
        { key: "dateReceived", value: "Date Received" },
        { key: "dateCompleted", value: "Date Completed" },
        { key: "practitionerDetails", value: "Practitioner Details" },
        { key: "patientDetails", value: "Patient Details" },
        { key: "type", value: "Type" },
        { key: "assessmentStatus", value: "Status" },
        { key: "patinetPreferredTime", value: "Contact" },
        { key: "action", value: "Action" }
    ];

    const goToOrderHistoryDetailPage = id => {
        history.push(appRoutes.instantSwitchOnlineAssessmentsDetails + "/" + id, {
            currPageNo: currFilters
        });
    };

    // get past onlineAssessment
    const getOrderHistory = (assessmentStatus) => {
        setIsProcessing(true);

        let apiUrl = getOrderHistoryAPI;
        let params = Object.assign(currFilters);

        if ((currFilters.text && currFilters.text.trim().length > 0) || (statusBlock || assessmentStatus)) {
            apiUrl = getOrderHistoryWithFilterAPI;
            const assessmentFilter = {
                assessmentStatus: assessmentStatus || statusBlock || ''
            };

            // target, source
            Object.assign(params, assessmentFilter);

        } else {
            delete params.text;
            delete params.filterType;
        }

        // add the assessment type filter in both api
        params['assessmentType'] = IS_ASSESSMENT_TYPES.SMOKING_CESSATION;

        setApiCallParams({
            reqType: "GET",
            reqUrl: apiUrl,
            params: params,
            successCallback: async res => {
                let list = [];
                await res.data.data.orderHistoryData.forEach(column => {
                    let d = {};
                    if (column.nurseId && column.nurseId !== "") {
                        column.doctorId = column.nurseId;
                        column.doctorId.doctorId = column.nurseId.nurseId;
                    }

                    d._id = column._id;
                    d.appointmentId = column.appointmentId;

                    console.log("Got the patient Id: ", column.patientId);

                    if (column.patientId !== null) {
                        d.patientEmail = column.patientId.email;
                        d.patientPhoneNo = column.patientId.phoneNumber;
                        d.patientName = column.patientId.firstName;
                        d.firstName = column.patientId.firstName;

                        if (
                            column.patientId.middleName !== "" ||
                            column.patientId.middleName !== null ||
                            column.patientId.middleName !== undefined ||
                            column.patientId.middleName !== "undefined"
                        ) {
                            d.patientName = d.patientName + " " + column.patientId.middleName;
                        }
                        d.patientName = d.patientName + " " + column.patientId.lastName;
                    } else {
                        d.patientEmail = "";
                        d.patientPhoneNo = "";
                        d.patientName = "";
                    }

                    d.createdAt = getFormattedDate(column.createdAt);
                    d.completedDate = column.completedDate ? getFormattedDate(column.completedDate) : '';
                    d.submittedDate = column.submittedDate ? getFormattedDate(column.submittedDate) : (column.createdAt ? getFormattedDate(column.createdAt) : '');

                    if (column.doctorId) {
                        d.doctorEmail = column.doctorId.email;
                        d.doctorPhoneNo = column.doctorId.phoneNumber;
                        d.doctorName = column.doctorId.firstName;

                        if (
                            column.doctorId.middleName !== "" ||
                            column.doctorId.middleName !== null ||
                            column.doctorId.middleName !== undefined ||
                            column.doctorId.middleName !== "undefined"
                        ) {
                            d.doctorName = d.doctorName + " " + column.doctorId.middleName;
                        }

                        d.doctorName = d.doctorName + " " + column.doctorId.lastName;
                    } else {
                        d.doctorPhoneNo = "";
                        d.doctorEmail = "";
                        d.doctorName = "";
                    }

                    d.isRequireSupport = column.isRequireSupport;

                    d.assessmentType = column.assessmentType || "Smoking Cessation";
                    d.assessmentStatus = column.isRequireSupport && column.assessmentStatus == ORDER_HISTORY_FILTERS.COMPLETED ? 'Support Required' : ORDER_HISTORY_STATUS[column.assessmentStatus];

                    let patinetPreferredTime = '';
                    if (column.doctorContactByTime && column.patinetPreferredTime) {
                        patinetPreferredTime = column.patinetPreferredTime;
                    } else if (column.doctorContactByTime) {
                        patinetPreferredTime = column.doctorContactByTime;
                    }

                    d.patinetPreferredTime = patinetPreferredTime;

                    console.log("Check Here -> ", column.assessmentStatus, column.isRequireSupport);

                    console.log("Now pusing this ", d);

                    if (column.isMedicareInvalid && column.assessmentStatus === ORDER_HISTORY_FILTERS.DRAFT) {
                        d.rowStyle = {
                            backgroundColor: "#98fb98",
                        };
                        d.assessmentStatus = 'Medicare Invalid';
                    }

                    if (column.isRequireSupport === true && column.assessmentStatus == ORDER_HISTORY_FILTERS.COMPLETED) {
                        d.rowStyle = {
                            backgroundColor: "#ff8fec",
                            color: "#000"
                        };
                    }

                    d.logs = column.logs ? column.logs : [];
                    d.internalNotes = column.internalNotes || "";

                    list.push(d);
                });

                setOnlineAssessment(list);
                setTotalRecords(res.data.data.orderHistoryDataCount);
                setIsProcessing(false);
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setErrModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowErrModal(true);
            }
        });
    };

    // export past onlineAssessment
    const exportConsults = async () => {
        setIsProcessing(true);

        var formData = new FormData();
        // formData.append("which", "PAST");
        formData.append("assessmentType", IS_ASSESSMENT_TYPES.SMOKING_CESSATION);

        if (
            filter &&
            filter === "1" &&
            startDate !== null &&
            endDate !== null &&
            startDate <= endDate
        ) {
            formData.append("startDate", converToUtc(startDate));
            console.log("endDate", typeof endDate, endDate)
            let dt = new Date(
                endDate.get("year"),
                endDate.get("month"),
                endDate.get("date") + 1,
                0,
                0,
                0
            ).toISOString();
            formData.append("endDate", converToUtc(dt));
        }

        if (statusBlock !== ORDER_HISTORY_FILTERS.ALL) {
            formData.append("assessmentStatus", statusBlock);
        }

        await setApiCallParams({
            reqType: "POST",
            reqUrl: exportOnlineAssessmentCSVAPI,
            dataObj: formData,
            successCallback: async res => {
                setIsProcessing(false);
                var fileURL = res.data.data;
                var a = document.createElement("a");
                a.href = fileURL;
                a.target = "_blank";
                a.download = "Past_Consults.csv";
                document.body.appendChild(a); //create the link "a"
                a.click(); //click the link "a"
                document.body.removeChild(a); //remove the link "a"
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setErrModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowErrModal(true);
            }
        });
    };

    const deleteOnlineAssessment = (id) => {
        setSelectedAssessment(id);
        setShowDeleteAssessmentModel(true);
    }

    const confirmDeleteAssessment = () => {
        setShowDeleteAssessmentModel(false);
        setIsProcessing(true);

        const dataToSend = {
            assessmentId: selectedAssessment
        };

        setApiCallParams({
            reqType: "POST",
            reqUrl: deleteOnlineAssessmentAPI,
            dataObj: dataToSend,
            successCallback: res => {
                setIsProcessing(false);
                getOrderHistory();
            },
            failureCallback: err => {
                setIsProcessing(false);
            }
        });
    }

    const openChangeDraftStatusModel = (id) => {
        setSelectedAssessment(id);
        console.log("---- selected assessment -=-- ", id);
        setOpenDraftStatusChangeModel(true);
    }

    const confirmChangeDraftToToBeAssess = () => {
        setOpenDraftStatusChangeModel(false);
        setIsProcessing(true);
        const dataToSend = {
            assessmentId: selectedAssessment,
            assessmentStatus: ORDER_HISTORY_FILTERS.DRAFT
        };
        setApiCallParams({
            reqType: "POST",
            reqUrl: changeOnlineAssessmentStatusAPI,
            dataObj: dataToSend,
            successCallback: res => {
                setIsProcessing(false);
                getOrderHistory();
            },
            failureCallback: err => {
                setIsProcessing(false);
            }
        });
    }

    const confirmChangePreferedTime = (timing) => {
        setOpenChangePreferredTimeModel(false);
        if (timing) {
            setIsProcessing(true);

            const dataToSend = {
                assessmentId: selectedAssessment,
                doctorContactByTime: timing.doctorContactByTime,
                patinetPreferredTime: timing.patientPreferredTime
            };

            setApiCallParams({
                reqType: "POST",
                reqUrl: updateDoctorContactByTimeAPI,
                dataObj: dataToSend,
                successCallback: res => {
                    setIsProcessing(false);
                    getOrderHistory();
                },
                failureCallback: err => {
                    setIsProcessing(false);
                    // setErrModalText(
                    //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                    // );
                    // setShowErrModal(true);
                }
            });
        }
    }

    const sendNotification = (message) => {
        setShowSendNotificationModal(false);
        const dataToSend = {
            assessmentId: selectedAssessmentData._id,
            message: message
        };

        setApiCallParams({
            reqType: "POST",
            reqUrl: sendNotificationToPatientFromInstantSwitch,
            dataObj: dataToSend,
            successCallback: res => {
                setIsProcessing(false);
                getOrderHistory();
                setErrModalText("Notification Sent Successfully");
                setShowErrModal(true);
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setErrModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowErrModal(true);
            }
        });
    }


    useEffect(() => {
        getOrderHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currFilters]);

    // restore the previous page state
    useEffect(() => {
        if (
            props.location.state &&
            props.location.state.currPageNo &&
            props.location.state.currPageNo !== null
        ) {
            setCurrFilters({
                skip: props.location.state.currPageNo.skip,
                limit: props.location.state.currPageNo.limit
            });
        }
    }, []);

    // const handleFilterChange = event => {
    //     setFilter(event.target.value);
    // };

    const handleStartDateChange = date => {
        setStartDate(date);
    };

    const handleEndDateChange = date => {
        setEndDate(date);
    };

    const clearFilter = () => {
        setStartDate(null);
        setEndDate(null);
        setFilter("1");
        setConsultNatureFilter(null);
        setConsultDurationFilter(null);
        setShowCrossIcon(false);
        let newFilter = Object.assign({}, currFilters);
        newFilter.skip = 0;
        if (newFilter.startDate) {
            delete newFilter.startDate;
        }
        if (newFilter.endDate) {
            delete newFilter.endDate;
        }
        if (newFilter.assessmentId) {
            delete newFilter.assessmentId;
        }
        if (newFilter.consultDetailId) {
            delete newFilter.consultDetailId;
        }
        if (newFilter.assessmentType) {
            delete newFilter.assessmentType;
        }
        setCurrFilters(newFilter);
    };

    const setTableFilters = filters => {
        let newFilter = Object.assign({}, currFilters);
        newFilter.limit = filters.limit;
        newFilter.skip = filters.skip;
        newFilter.text = filters.text;
        newFilter.filterType = filters.filterType;

        setCurrFilters(newFilter);
    };

    const sortTableDataByColumn = SelColumn => {
        let sortedData = sortData(SelColumn.column, SelColumn.order, onlineAssessment);
        setOnlineAssessment(sortedData);
    };

    const applySelectedFilter = () => {
        let newFilter = Object.assign({}, currFilters);
        setShowCrossIcon(true);

        newFilter.skip = 0;

        if (newFilter.startDate) {
            delete newFilter.startDate;
        }
        if (newFilter.endDate) {
            delete newFilter.endDate;
        }
        if (newFilter.assessmentId) {
            delete newFilter.assessmentId;
        }
        if (newFilter.consultDetailId) {
            delete newFilter.consultDetailId;
        }

        if (
            filter === "1" &&
            startDate !== null &&
            endDate !== null &&
            startDate <= endDate
        ) {
            newFilter.startDate = converToUtc(startDate);
            let dt = new Date(
                endDate.get("year"),
                endDate.get("month"),
                endDate.get("date") + 1,
                0,
                0,
                0
            ).toISOString();
            newFilter.endDate = converToUtc(dt);
            setCurrFilters(newFilter);
        }

        if (filter === "2" && consultNatureFilter !== null) {
            newFilter.assessmentId = consultNatureFilter;
            setCurrFilters(newFilter);
        }

        if (filter === "3" && consultDurationFilter !== null) {
            newFilter.consultDetailId = consultDurationFilter;
            setCurrFilters(newFilter);
        }
    };

    const handleStatusFilterChange = e => {
        setStatusBlock(e.target.value);
        getOrderHistory(e.target.value);
    };

    const saveExtraNotes = (note) => {
        console.log("Now I'll save Extra notes here: ", note);

        setShowLogsModel(false);
        const dataToSend = {
            assessmentId: selectedAssessmentData._id,
            internalNotes: note
        };

        setApiCallParams({
            reqType: "POST",
            reqUrl: addInternalNotesToAssessmentFromInstantSwitch,
            dataObj: dataToSend,
            successCallback: res => {
                setIsProcessing(false);
                setErrModalText("Notes Added Successfully");
                setShowErrModal(true);
                getOrderHistory();
            },
            failureCallback: err => {
                setIsProcessing(false);
                // setErrModalText(
                //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
                // );
                // setShowErrModal(true);
            }
        });
    }

    return (
        <Fragment>
            {isProcessing && <Loader />}
            <div className={isProcessing ? "disableContainer" : ""}>
                <div className="view-ticket-container">
                    <CustomModal
                        useOneButton={true}
                        cancelText="OKAY"
                        openModal={showErrModal}
                        cancelEvent={() => {
                            setShowErrModal(false);
                            setErrModalText("");
                        }}
                        modalBodyContent={
                            <p className="text-center mb-0"
                                dangerouslySetInnerHTML={{
                                    __html: errModalText
                                }}/>
                        }
                    />
                    <div className="row p-0 m-0">
                        <div className="col-sm-4 mt-1 pt-3 pl-0 row">
                            <div className="d-flex flex-column">
                                <img src={Logo} style={{ width: "150px", display: "inline", margin: "8px" }} />
                                <h3 style={{ marginLeft: '8px' }}>Online Assessments</h3>
                            </div>
                        </div>
                        <div className="col-sm-8 page-heading-options-align">
                            <div className="row">
                                <div className="col-sm-12 p-0">
                                    {filter === "1" && (
                                        <div className="d-flex justify-content-end">
                                            <TextField
                                                select
                                                SelectProps={{
                                                    native: true
                                                }}
                                                onChange={handleStatusFilterChange}
                                                value={statusBlock}
                                                className="mt-3 pt-1 ml-3"
                                            >
                                                <option value="" disabled>Select Status</option>
                                                <option value={ORDER_HISTORY_FILTERS.DRAFT}>Draft</option>
                                                <option value={ORDER_HISTORY_FILTERS.TO_BE_ASSESSED}>To Be Assessed</option>
                                                <option value={ORDER_HISTORY_FILTERS.ACCEPTED}>Accepted</option>
                                                <option value={ORDER_HISTORY_FILTERS.COMPLETED}>Completed</option>
                                                <option value={ORDER_HISTORY_FILTERS.REJECTED}>Rejected</option>
                                                <option value={ORDER_HISTORY_FILTERS.ALL}>All</option>
                                            </TextField>
                                            <KeyboardDatePicker
                                                name="startDate"
                                                style={{ width: "135px", marginLeft: "20px" }}
                                                autoOk
                                                variant="inline"
                                                mask="__-__-____"
                                                format="DD-MM-YYYY"
                                                label="Start Date"
                                                value={startDate}
                                                onChange={date => handleStartDateChange(date)}
                                            />
                                            <KeyboardDatePicker
                                                name="endDate"
                                                style={{ width: "135px", marginLeft: "20px" }}
                                                autoOk
                                                variant="inline"
                                                mask="__-__-____"
                                                format="DD-MM-YYYY"
                                                label="End Date"
                                                value={endDate}
                                                onChange={date => handleEndDateChange(date)}
                                            />
                                            {/*{*/}
                                            {/*    !showCrossIcon && (*/}
                                            {/*        <button*/}
                                            {/*            style={{ minWidth: "30px", width: "30px" }}*/}
                                            {/*            className="insta-button-primary ml-3 mt-3"*/}
                                            {/*            onClick={applySelectedFilter}*/}
                                            {/*        >*/}
                                            {/*            <i className="fas fa-arrow-right" aria-hidden="true"></i>*/}
                                            {/*        </button>*/}
                                            {/*    )*/}
                                            {/*}*/}

                                            {showCrossIcon && (
                                                    <button
                                                        style={{ minWidth: "30px", width: "30px" }}
                                                        className="insta-button-primary ic-btn-red mt-3 ml-3"
                                                        onClick={clearFilter}
                                                    >
                                                        <i className="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                )
                                            }

                                            <Button
                                                clickEvent={exportConsults}
                                                title="Export to CSV"
                                                className="mt-3 ml-3"/>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="table-without-striped">
                        <CustomDataTableSearchByFilter
                            totalRecords={totalRecords}
                            headers={tableHeaders}
                            setFilters={setTableFilters}
                            sortData={sortTableDataByColumn}
                            tabFilters={currFilters}
                            disbleAll={true}
                            searchFilterList={searchFilterList.onlineAssessmentSearchFilterList}
                        >
                            {onlineAssessment.map((item, index) => (
                                <tr
                                    key={index}
                                    className="row-no-hover-effect"
                                    style={item.rowStyle}
                                    onClick={e => {
                                        e.preventDefault();
                                        if (item.assessmentStatus !== "Draft") {
                                            goToOrderHistoryDetailPage(item._id);
                                        }
                                    }}
                                >
                                    <td>{item.appointmentId}</td>
                                    <td>{item.submittedDate}</td>
                                    <td>{item.completedDate}</td>
                                    <td>
                                        <div className="d-flex flex-column position-relative">
                                            <p
                                                className={
                                                    item.doctorConnectionAttempt !== 1 &&
                                                        item.doctorConnectionAttempt !== undefined
                                                        ? "color-red mb-0"
                                                        : "mb-0"
                                                }
                                            >
                                                <b>{item.doctorName}</b>
                                            </p>
                                            <a
                                                onClick={e => {
                                                    e.stopPropagation();
                                                }}
                                                className="high-z-index list-email"
                                                href={"mailto:" + item.doctorEmail}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {item.doctorEmail}
                                            </a>
                                            <ICPhoneDisplay value={item.doctorPhoneNo} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column position-relative">
                                            <p
                                                className={
                                                    item.patientConnectionAttempt !== 1 &&
                                                        item.patientConnectionAttempt !== undefined
                                                        ? "color-red mb-0"
                                                        : "mb-0"
                                                }
                                            >
                                                <b>{item.patientName}</b>
                                            </p>
                                            <a
                                                onClick={e => {
                                                    e.stopPropagation();
                                                }}
                                                className="high-z-index list-email"
                                                href={"mailto:" + item.patientEmail}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {item.patientEmail}
                                            </a>
                                            <ICPhoneDisplay value={item.patientPhoneNo} />
                                        </div>
                                    </td>
                                    <td>
                                        {item.assessmentType}
                                    </td>
                                    <td onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        if (item.assessmentStatus === 'Medicare Invalid') {
                                            setSelectedAssessment(item._id);
                                            openChangeDraftStatusModel(item._id);
                                        }
                                    }}>
                                        {item.assessmentStatus}
                                    </td>
                                    <td onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setSelectedAssessment(item._id);
                                        setOpenChangePreferredTimeModel(true)
                                    }
                                    }>
                                        {item.patinetPreferredTime ? `${item.patinetPreferredTime} AEST` : '-'} 
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-center align-item-center">

                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log("Selected data: ", item);
                                                    setSelectedAssessmentData(item);
                                                    setShowLogsModel(true);
                                                }}
                                                type="button"
                                                className="btn btn-out-grey-2 high-z-index float-left ml-3"
                                            >
                                                <i
                                                    className="fas fa-file cursor-point cursor-pointer insta-gray"

                                                ></i>
                                            </button>

                                            <button
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    setSelectedAssessmentData(item);
                                                    setShowSendNotificationModal(true);
                                                }}
                                                type="button"
                                                className="btn btn-out-bell high-z-index float-left ml-3"
                                            >
                                                <i className="fas fa-bell"></i>
                                            </button>

                                            <button
                                                style={{ minWidth: "30px", width: "30px" }}
                                                className="insta-button-primary btn-out-delete ml-3"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    deleteOnlineAssessment(item._id)
                                                }
                                                }
                                            >
                                                <i className="fas fa-trash-alt" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </CustomDataTableSearchByFilter>
                    </div>

                    <CustomModal
                        openModal={showDeleteAssessmentModel}
                        useOneButton={false}
                        cancelEvent={() => {
                            setShowDeleteAssessmentModel(false);
                        }}
                        cancelText="Close"
                        okayEvent={confirmDeleteAssessment}
                        okayText="Confirm"
                        title="Instant Switch"
                        modalBodyContent={
                            <p>Are you sure you want to delete this assessment?</p>
                        }

                    />


                    <CustomModal
                        openModal={openChangePreferredTimeModel}
                        useOneButton={false}
                        noFooterButtons={true}
                        cancelEvent={() => {
                            setOpenChangePreferredTimeModel(false);
                        }}
                        cancelText="Close"
                        okayEvent={confirmChangePreferedTime}
                        okayText="Confirm"
                        title={<p className="text-center mb-0">Instant Switch</p>}
                        modalBodyContent={
                            <Fragment>
                                <InstantSwitchPatientContactForm onCancle={() => setOpenChangePreferredTimeModel(false)} onFormSubmit={(timing) => confirmChangePreferedTime(timing)} />
                            </Fragment>
                        }

                    />

                    <CustomModal
                        openModal={openDraftStatusChangeModel}
                        useOneButton={false}
                        cancelEvent={() => {
                            setOpenDraftStatusChangeModel(false);
                        }}
                        cancelText="Close"
                        okayEvent={confirmChangeDraftToToBeAssess}
                        okayText="Confirm"
                        title={<p className="text-center mb-0">Instant Switch</p>}
                        modalBodyContent={
                            <Fragment>
                                <p>Are you sure you want to change the status to 'Draft'?</p>
                            </Fragment>
                        }

                    />


                    {/* Send Notification Model */}
                    <CustomModal
                        openModal={showSendNotificationModal}
                        className={"instantswitch-p-notification-model"}
                        cancelEvent={() => {
                            setShowSendNotificationModal(false);
                            setSelectedAssessmentData({});
                        }}
                        title="Send Notification"
                        modalBodyContent={
                            <SendInstantSwitchNotificationForm
                                onFormSubmit={sendNotification}
                                patientName={selectedAssessmentData.firstName}
                            />
                        }
                        noFooterButtons={true}
                    />

                    {/* Check Notification Logs Model */}
                    <CustomModal
                        useOneButton={true}
                        noFooterButtons={true}
                        cancelText="CLOSE"
                        title="Patient Notified"
                        openModal={showLogsModel}
                        modalBodyContent={
                            <Fragment>
                                {selectedAssessmentData && selectedAssessmentData.logs && selectedAssessmentData.logs.length ? selectedAssessmentData.logs.map((value, index) => {
                                    return (
                                        <div key={index} className="row p-0 m-0 text-left">
                                            <div
                                                className="col-sm-12 pl-0 mt-1 cursor-pointer"
                                                id={'toolTipId' + index}
                                            >
                                                <span className="text-success mr-1">
                                                    <i className="fas fa-check"></i>
                                                </span>
                                                <span>
                                                    {momentTz(value.createdAt)
                                                        .tz("Australia/Brisbane")
                                                        .format("DD-MM-YYYY hh:mm A")}
                                                </span>
                                                <span className="ml-3">
                                                    {
                                                        value.sentBy === "System System" ? (
                                                            "Automated | Instant Consult"
                                                        ) : (
                                                            value.sentBy
                                                        )
                                                    }
                                                </span>
                                                <UncontrolledTooltip
                                                    placement="bottom"
                                                    target={'toolTipId' + index}
                                                    fade={true}
                                                >
                                                    {value.message
                                                        ? value.message
                                                        : ""}
                                                </UncontrolledTooltip>
                                            </div>
                                        </div>
                                    );
                                }) : <p>No Data Found</p>
                                }
                                <hr />
                                <div className="mt-3">
                                    {
                                        props.user && props.user.userType !== "SUPPORT_STAFF" ? (
                                            <InternalNotesForPatientInstantSwitchForm internalNotes={selectedAssessmentData.internalNotes} onFormSubmit={saveExtraNotes} cancelEvent={() => {
                                                setShowLogsModel(false);
                                            }} />
                                        ) : (
                                            <Button title="Close" type="button" className="ml-2 m-auto" clickEvent={() => {
                                                setShowLogsModel(false);
                                            }} />
                                        )
                                    }

                                </div>
                            </Fragment>
                        }
                    />

                    {/* API Call */}
                    <MakeAPICall apiParam={apiCallParams} />
                    <MakeAPICall apiParam={apiCallParams1} />
                    <MakeAPICall apiParam={apiCallParams2} />
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    user: state.auth.user
});

export default connect(mapStateToProps, null)(OnlineAssessmentListPage);
